import {styled} from "@mui/material/styles";

// Ausserhalb der Funktion, sonst entsteht bei jedem Rendern eine neue Komponente und der Inhalt wird komplett neu aufgebaut.
const DhDiv = styled('div')(({ theme }) => ({
    display: 'block',
    [theme.breakpoints.up("md")]: {
        display: 'none',
    },
}));

export default function DHMobileDiv ({comp}) {
    return <DhDiv>{comp}</DhDiv>
}
